import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userPatch } from "../../store/auth/actions";
export var useUserPatch = function (trigger, bodyRequest, userId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseUserPatch: (_a = state.Login.responseUserPatch) === null || _a === void 0 ? void 0 : _a.data,
            errorUserPatch: state.Login.errorUserPatch,
            loadingUserPatch: state.Login.loadingUserPatch,
        });
    }), responseUserPatch = _a.responseUserPatch, errorUserPatch = _a.errorUserPatch, loadingUserPatch = _a.loadingUserPatch;
    useEffect(function () {
        if (trigger) {
            dispatch(userPatch({ bodyRequest: bodyRequest, userId: userId }));
        }
    }, [bodyRequest, userId, trigger]);
    return {
        responseUserPatch: responseUserPatch,
        errorUserPatch: errorUserPatch,
        loadingUserPatch: loadingUserPatch,
    };
};
